import styled from "@emotion/styled";
import React from "react";
import { MEDFLYT_DECORATIVE_LOGO } from "../../../utils/svgs_new";

type Props = Record<PropertyKey, unknown>;

const VerticalLogo = (_props: Props, ref: React.Ref<HTMLDivElement>) => {
  return (
    <VerticalLogo.Styled ref={ref} style={{ width: 150 }}>
      {MEDFLYT_DECORATIVE_LOGO}
    </VerticalLogo.Styled>
  );
};

VerticalLogo.Styled = styled.div`
  color: #0a77e6;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  .AppIcon {
    width: 100%;
  }
`;

export default Object.assign(React.forwardRef(VerticalLogo), {
  Styled: VerticalLogo.Styled,
});
